// extracted by mini-css-extract-plugin
export default {"container":"WasteTypeCard_container__acRFN","text":"WasteTypeCard_text__cTbLT","id":"WasteTypeCard_id__JR0vn","selected":"WasteTypeCard_selected__GXIOb"};